import { arrangeValuesByComparingDimension } from './arrangeValuesByComparingDimension';
import { getBarChartDimensionInfo } from './prepareBarChartDimension';
import {
	getAllAxisLabels,
	getAllLegendLabels,
	getBarCountInfo,
} from './barChartInfo';
import { getBarChartYAxisEtries } from './getBarChartYAxisEtries';
import {
	WebAPIBarGraphChartSlicerData,
	WebAPIDataEntryList,
} from '../../../../globals/webApiTypes/elements/WebAPICBS';
import { getGlobalDataProperties } from '../../helpers/getGlobalDataProperties';

export const getBarChartProps = (
	props: { dataEntryList: WebAPIDataEntryList } & WebAPIBarGraphChartSlicerData,
) => {
	const {
		dataEntryList,
		comparingDimension,
		yAxisDimension,
		topicKeys,
		categoryKeys,
		selectedTopics,
		selectedCategories,
		selectedDimensions,
		labelAliases,
	} = props;

	const decimals = Object.values(selectedTopics)?.[0].decimals ?? 0;
	const unit = Object.values(selectedTopics)?.[0].unit ?? '';

	const valuesByComparingDimension = arrangeValuesByComparingDimension({
		dataEntryList,
		comparingDimension,
		yAxisDimension,
		topicKeys,
		categoryKeys,
		selectedTopics,
		selectedCategories,
		labelAliases,
	});
	const yAxisEntries = getBarChartYAxisEtries({
		valuesByComparingDimension,
		yAxisDimension,
		topicKeys,
		categoryKeys,
		selectedTopics,
		selectedCategories,
		labelAliases,
	});
	const globalDataProperties = getGlobalDataProperties({
		dimensionInfo: valuesByComparingDimension,
		decimals,
	});
	const barCountInfo = getBarCountInfo(valuesByComparingDimension);

	const allAxisLabels = getAllAxisLabels(valuesByComparingDimension);
	const allLegendLabels = getAllLegendLabels(valuesByComparingDimension);

	const yAxisDimensionInfo = getBarChartDimensionInfo({
		labelAliases,
		dimensionKey: yAxisDimension,
		selectedDimensions,
	});
	const comparingDimensionInfo = getBarChartDimensionInfo({
		labelAliases,
		dimensionKey: comparingDimension,
		selectedDimensions,
	});

	const legend = {
		hasLegend: comparingDimension !== yAxisDimension,
		title: comparingDimensionInfo.legendLabel,
		labels: allLegendLabels,
	};

	const axis = {
		yAxisDimension,
		yAxisDimensionInfo,
		yAxisEntries,
		labels: allAxisLabels,
	};

	return {
		...props,
		...globalDataProperties,
		...barCountInfo,
		valuesByComparingDimension,
		comparingDimensionInfo,
		unit,
		decimals,
		legend,
		axis,
	};
};
